import * as React from "react";
const SvgBBIconsUncertainDirection = (props) => (
  <svg
    width="22"
    height="8"
    viewBox="0 0 22 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      y1="4.15002"
      x2="18.6027"
      y2="4.15002"
      stroke="black"
      stroke-width="2"
    />
    <path
      d="M15.0012 4C15.0012 2.34315 16.3444 1 18.0012 1V1C19.6581 1 21.0012 2.34315 21.0012 4V4C21.0012 5.65685 19.6581 7 18.0012 7V7C16.3444 7 15.0012 5.65685 15.0012 4V4Z"
      fill="white"
      stroke="black"
    />
  </svg>
);
export default SvgBBIconsUncertainDirection;
